// SEO defaults and schema.org structured data for Holder Hospitality Consulting
export const SITE_URL = "https://holderhospitality.consulting";
export const SITE_NAME = "Holder Hospitality Consulting";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

// LocalBusiness + ProfessionalService combined JSON-LD
// Schema.org allows multi-type via @type as an array
export const businessSchema = {
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "ProfessionalService"],
  "@id": `${SITE_URL}#business`,
  name: "Holder Hospitality Consulting",
  alternateName: "HHC",
  url: SITE_URL,
  logo: `${SITE_URL}/og-image.png`,
  image: `${SITE_URL}/og-image.png`,
  description:
    "Fractional COO, interim president, and operations consulting services for restaurant, hospitality, and food service operators. Kansas City based, serving clients nationally.",
  founder: [
    {
      "@type": "Person",
      name: "Caleb R. Holder, DBA",
      jobTitle: "Founder & CEO",
      sameAs: ["https://linkedin.com/in/crholder"],
    },
    {
      "@type": "Person",
      name: "Jake Lair",
      jobTitle: "Co-Founder & COO",
      sameAs: ["https://www.linkedin.com/in/jacoblair/", "https://foundryis.com"],
    },
  ],
  foundingDate: "2024-10",
  email: "caleb@holderhospitality.consulting",
  areaServed: {
    "@type": "Country",
    name: "United States",
  },
  address: {
    "@type": "PostalAddress",
    addressLocality: "Kansas City",
    addressRegion: "MO",
    addressCountry: "US",
  },
  priceRange: "$$$",
  serviceType: [
    "Fractional COO",
    "Interim President",
    "Operational Excellence",
    "People Operations and Recruiting",
    "The Operator Walk",
  ],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Consulting Services",
    itemListElement: [
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Fractional Executive Leadership",
          description:
            "Fractional COO and interim president services for restaurant and hospitality companies in transition, turnaround, or growth.",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Operational Excellence",
          description:
            "Comprehensive evaluation and optimization of restaurant operations including food and labor cost, workflow design, and multi-unit systems.",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "People Operations and Recruiting",
          description:
            "Fractional HR leadership, executive search, training and onboarding design, and workforce planning.",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "The Operator Walk",
          description:
            "A monthly senior operator review of your restaurant. A 20-point on-site inspection across five operational disciplines, delivered through a private client dashboard with trend tracking and prioritized recommendations.",
        },
      },
    ],
  },
  sameAs: ["https://linkedin.com/in/crholder"],
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}#website`,
  url: SITE_URL,
  name: SITE_NAME,
  publisher: { "@id": `${SITE_URL}#business` },
};

export const personSchema = {
  "@context": "https://schema.org",
  "@type": "Person",
  "@id": `${SITE_URL}/about#person`,
  name: "Caleb R. Holder, DBA",
  jobTitle: "Fractional Chief Operating Officer",
  worksFor: { "@id": `${SITE_URL}#business` },
  description:
    "Fractional COO, interim president, and operations executive with 20+ years leading restaurant and hospitality operations.",
  url: `${SITE_URL}/about`,
  image: `${SITE_URL}/images/caleb.png`,
  sameAs: ["https://linkedin.com/in/crholder"],
  hasCredential: [
    {
      "@type": "EducationalOccupationalCredential",
      credentialCategory: "degree",
      name: "Doctor of Business Administration (DBA), Organizational Leadership",
    },
    {
      "@type": "EducationalOccupationalCredential",
      credentialCategory: "certification",
      name: "ServSafe Certified Instructor and Registered Proctor",
    },
  ],
};

export const jakeSchema = {
  "@context": "https://schema.org",
  "@type": "Person",
  "@id": `${SITE_URL}/about#jake`,
  name: "Jake Lair",
  jobTitle: "Co-Founder & Chief Operating Officer",
  worksFor: { "@id": `${SITE_URL}#business` },
  description:
    "Operations executive with a career spanning nuclear operations, manufacturing, and hospitality. Co-founder and COO of Holder Hospitality Consulting and founder of FOUNDRY Solutions.",
  url: `${SITE_URL}/about`,
  image: `${SITE_URL}/images/jake.png`,
  sameAs: ["https://www.linkedin.com/in/jacoblair/", "https://foundryis.com"],
};
